







































































import 'vue-height-tween-transition/index.css'
import HeightTween from 'vue-height-tween-transition'


export default

	components: { HeightTween }

	name: "formRadioItem"

	props:
		option:
			type: Object
			required: true

		value: [String, Number]

		loading: Boolean

		type:
			type: String
			default: "standard"

		groupLabel:
			type: String
			default: 'radio-group'

		tabindex:
			type: String
			default: '0'

		showRadio:
			type: Boolean
			default: true

		isSubscribing: Boolean
		allocations: Array
		sellingPlanId: String

	methods:
		onChange: (val) ->
			@$emit('selling-plan-change', val)

